export default __webpack_public_path__ + "static/media/date.530a2455.png";